import type {FC} from 'react';

import type {Props} from './types';

import {platform} from '../../../../utils/platform';
import {DMChannelsListItem} from './components/DMChannelsListItem';
import {ProgramChannelsListItem} from './components/ProgramChannelsListItem';
import * as S from './styles';

export const SelectableChannelsListItem: FC<Props> = ({
  channel,
  isDisabled,
  isMultiselect = false,
  isSelected,
  onClick,
}) => {
  return (
    <S.Container disabled={isDisabled} onClick={() => onClick(channel)}>
      <S.ChannelCheckbox
        checked={isSelected}
        disabled={isDisabled}
        onClick={platform.isNative ? () => onClick(channel) : undefined}
        variant={isMultiselect ? 'default' : 'circle'}
      />
      {channel.type === 'private' ? (
        <DMChannelsListItem channel={channel} />
      ) : (
        <ProgramChannelsListItem channel={channel} isDisabled={isDisabled} />
      )}
    </S.Container>
  );
};
